import React, { useState, useEffect } from "react";
import { Modal } from "../UI/general";
export const ModalContext = React.createContext();

export default function ModalProvider({ children }) {
  let [Component, setComponent] = useState(null);
  const dispatch = Fn => {
    setComponent(() => Fn);
  };
  useEffect(() => {}, [Component]);
  return (
    <ModalContext.Provider value={dispatch}>
      {Component ? (
        <Modal isOpen={true}>
          <Component close={() => setComponent(null)}></Component>
        </Modal>
      ) : null}
      {children}
    </ModalContext.Provider>
  );
}
